<div class="radio-btn__group__wrapper"
     [ngClass]="{'large-block': largeBlock, 'active': checked && largeBlock, 'disable': disabled}">
    <mat-radio-button
            [tabIndex]="0"
            [name]="nameForIsolation"
            [checked]="checked"
            [disabled]="disabled"
            [value]="value"
            [aria-label]="ariaLabel"
            [attr.aria-checked]="checked"
            (change)="radioButtonChanged.emit(value)">
        <p [ngStyle]="{'font-weight': labelFontWeight}">{{label}}<br>
            <span class="label-info">{{labelDescription}}</span>
        </p>
    </mat-radio-button>
</div>
